import './Achievements.css'
import { RxDotFilled } from 'react-icons/rx';
import Fade from 'react-reveal/Fade';

export default function Achievements(){
    return(
        <div id='achievements' className='d-flex justify-content-around my-5'>
            <div>
                <Fade>
                    <h1 id='big' >Film Surro</h1>
                </Fade>
                <div id='surro-content' className='w-100 ps-5'>
                    <Fade cascading bottom>
                        <div>
                            <h4>MIP Awards 6</h4>
                            <p className='mb-0'>
                                Nominasi Pengarah Artistik Terbaik<RxDotFilled/>
                            </p>
                            <p>
                                Pemenang Pengarah Artistik Terbaik<RxDotFilled/>
                            </p>
                        </div>
                    </Fade>
                    <Fade cascading bottom>
                        <div>
                            <h4>Lift-Off Global Network</h4>
                            <p>Official Selection Sessions 2022<RxDotFilled/></p>
                        </div>
                    </Fade>
                    <Fade cascading bottom>
                        <div>
                            <h4>Jakarta Film Week 2022</h4>
                            <p>"Official Selection 2022 "Her Story<RxDotFilled/></p>
                        </div>
                    </Fade>
                    <Fade cascading bottom>
                        <div>
                            <h4>Satu Layar</h4>
                            <p>Official Selection Sinema Pendidikan 2022<RxDotFilled/></p>
                        </div>
                    </Fade>
                    <Fade cascading bottom>
                        <div>
                            <h4>Brawijaya Film Festival</h4>
                            <p>Official Selection 2022<RxDotFilled/></p>
                        </div>
                    </Fade>
                    <Fade cascading bottom>
                        <div>
                            <h4>Festival Film Bulanan</h4>
                            <p>Official Selection Lokus 3<RxDotFilled/></p>
                        </div>
                    </Fade>
                    <Fade cascading bottom>
                        <div>
                            <h4>Brawijaya Movie Vol.9</h4>
                            <p>Official Selection Program Sajak Nestapa<RxDotFilled/></p>
                        </div>
                    </Fade>
                    <Fade cascading bottom>
                        <div>
                            <h4>Sinema Akhir Tahun</h4>
                            <p>Official Selection 2022<RxDotFilled/></p>
                        </div>
                    </Fade>
                    <Fade cascading bottom>
                        <div>
                            <h4>Festival Film Pendek Sumedang 2022</h4>
                            <p>Official Selection Competition<RxDotFilled/></p>
                        </div>
                    </Fade>
                </div>
            </div>
            <Fade cascading>
                <img src="./Project/6-potong.png" alt="" />
            </Fade>
            <Fade>
                <h1 id='small'>Film Surro</h1>
            </Fade>
        </div>
    )
}